import { SyntheticEvent } from 'react';

const stopEventBubble = (event: SyntheticEvent | KeyboardEvent) => {
  event.preventDefault();
  event.stopPropagation();
};

export default stopEventBubble;
